import formMixin from '../../formMixin';
import get from 'lodash/get';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
export default {
  name: 'NiotaClassicDevicetypesPacketParserMulti',
  mixins: [formMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      formComponent: null,
      parserPath: null,
      showFormDialog: false,
      parserDuplicateKeysPrompt: false,
      // for display, keep the data separated from `parserConfigInternal`
      // only update from __switch parser if the user hits `Save`
      switchParsers: {},
      parserConfigInternal: {},
      lastEmittedConfig: {}
    };
  },
  computed: {
    borderColor() {
      return this.UiTheme ? 'rgba(255, 255, 255, 0.25)' : 'transparent';
    },
    formElement() {
      return this.formComponent;
    },
    dialogButtons() {
      return [{
        icon: 'fal fa-check-square',
        title: this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.presave'),
        action: 'save',
        type: this.readonly ? 'button' : 'submit',
        valid: this.readonly ? false : undefined
      }, {
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    dialogTitle() {
      if (this.parserPath === '__switch') {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editSwitchParser');
      } else if (this.parserPath === '__default') {
        return this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.editDefaultParser');
      }
      return this.parserPath;
    },
    switchParserList() {
      return Object.keys(this.switchParsers).filter(p => p !== '__switch' && p !== '__default').sort((a, b) => a.localeCompare(b));
    }
  },
  watch: {
    parserConfig: {
      handler(val) {
        if (!val) {
          this.parserConfigInternal = {};
          return;
        }
        this.parserConfigInternal = cloneDeep(val);
      },
      deep: true,
      immediate: true
    },
    parserConfigInternal() {
      this.updateSwitchParsers();
    }
  },
  created() {
    this.updateSwitchParsers();
  },
  methods: {
    generateCopyName(name) {
      const matchCopy = name.match(/_(\d+)$/) || [];
      const copyNum = parseInt(matchCopy[1], 10);
      if (!copyNum) {
        return `${name}_1`;
      }
      return name.replace(/_(\d)$/, `_${copyNum + 1}`);
    },
    duplicateParser(parser) {
      let dupeName = parser;

      // look if the dupeName is already used in the switchParserList and if so the next one
      while (this.switchParserList.indexOf(dupeName) >= 0) {
        dupeName = this.generateCopyName(dupeName);
      }
      const switchParserEntry = find(this.parserConfigInternal.__switch.calculateElements, {
        target: parser
      });
      this.parserConfigInternal.__switch.calculateElements.push({
        target: dupeName,
        formula: switchParserEntry.formula
      });
      this.switchParsers.__switch.calculateElements.push({
        target: dupeName,
        formula: switchParserEntry.formula
      });
      this.switchParserList.push(dupeName);
      this.switchParsers[dupeName] = cloneDeep(this.switchParsers[parser]);
      this.parserConfigInternal[dupeName] = cloneDeep(this.parserConfigInternal[parser]);
      this.updateSwitchParsers();
    },
    editParser(path) {
      this.parserPath = path;
      if (!this.parserConfigInternal[path]) {
        this.parserConfigInternal[path] = {};
      }
      this.parserConfigInternal[path].variables = get(this.parserConfigInternal, `${path}.variables`) || {};
      this.parserConfigInternal[path].calculateElements = get(this.parserConfigInternal, `${path}.calculateElements`) || [];
      this.updateSwitchParsers();
      this.$nextTick(() => {
        this.formComponent = path === '__switch' ? get(this.$refs, 'form') : get(this.$refs, 'single-parser.$refs.form');
      });
      this.showFormDialog = true;
    },
    formulaForSwitchParser(switchParser) {
      return (get(this.switchParsers, '__switch.calculateElements', []).find(ce => ce.target === switchParser) || {}).formula;
    },
    updateSwitchParsers() {
      let updatedSwitchParsers = cloneDeep(this.parserConfigInternal);

      // keep switch switch-variables and parsers in sync
      // step 1: add
      const calculateElements = get(this.parserConfigInternal, '__switch.calculateElements', []);
      calculateElements.forEach(element => {
        updatedSwitchParsers[element.target] = updatedSwitchParsers[element.target] || this.parserConfigInternal[element.target] || {
          variables: {},
          calculateElements: []
        };
      });
      // step 2: delete
      Object.keys(updatedSwitchParsers).forEach(parser => {
        if (parser !== '__switch' && parser !== '__default') {
          if (calculateElements.findIndex(e => e.target === parser) === -1) {
            delete updatedSwitchParsers[parser];
          }
        }
      });
      updatedSwitchParsers['__default'] = cloneDeep(this.parserConfigInternal['__default'] || updatedSwitchParsers['__default'] || {
        variables: {},
        calculateElements: []
      });
      this.switchParsers = cloneDeep(updatedSwitchParsers);
      // this.parserConfigInternal = cloneDeep(updatedSwitchParsers);
    },
    onparserConfigInternalUpdated(val) {
      const clonedConfig = cloneDeep(this.parserConfigInternal);
      clonedConfig[this.parserPath] = cloneDeep(val);
      this.parserConfigInternal = clonedConfig;
    },
    saveParserPreflight() {
      const calculations = get(this.switchParsers[this.parserPath], 'calculateElements', []);
      const lowercase_keys = calculations.map(entry => entry.target.toLowerCase());
      const unique_keys = new Set(lowercase_keys);
      if (lowercase_keys.length !== unique_keys.size) {
        this.parserDuplicateKeysPrompt = true;
        return;
      }
      this.save();
    },
    save() {
      this.parserConfigInternal[this.parserPath] = this.switchParsers[this.parserPath];
      this.emitChanges();

      // NOTE: there is the "save" button outside of this component in `wrapper.vue`
      // so do not perform actual saving to the back-end here, this is just a "runtime save" of edited dialog content
      if (this.parserPath === '__switch') {
        this.updateSwitchParsers();
      }
      this.showFormDialog = false;
    },
    emitChanges() {
      const clonedparserConfigInternal = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', clonedparserConfigInternal);
    }
  }
};